<script setup lang="ts">
import BaseInputText from '../../base/BaseInputText.vue'
import BaseInputCheckbox from '../../base/BaseInputCheckbox.vue'
import BaseButtonSecondary from '../../base/BaseButtonSecondary.vue'
import { reactive } from 'vue'
import { useForm } from 'vee-validate'
import { postManager } from '../../../utilities/api'
import { useLegalAccountDataState } from '../../../utilities/account/useAccountDataLegal'
import { notify } from '../../../utilities/useNotifications'
import { i18n } from '../../../localization'

const initialValue = {
    first_name: '',
    last_name: '',
    email: '',
    is_beneficial_owner: false,
}

const formValues = reactive({ ...initialValue })

const form = useForm({
    validationSchema: {
        first_name: 'required',
        last_name: 'required',
        email: 'required',
        is_beneficial_owner: '',
    },
})

async function addManager() {
    const { valid } = await form.validate()
    const state = useLegalAccountDataState()

    if (valid) {
        postManager(state.legalProfile.legal_profile_uid, formValues).then(() => {
            Object.assign(formValues, initialValue)
            form.resetForm()
            notify('Success', i18n.global.t('legal_account_managers.manager_invited_notice'))
            state.fetchAccountData()
        })
    }
}
</script>

<template>
    <div>
        <div class="grid grid-cols-1 gap-x-4 gap-y-3 pt-2 sm:grid-cols-6">
            <div class="sm:col-span-3">
                <BaseInputText v-model="formValues.first_name" name="first_name" label="First Name"></BaseInputText>
            </div>

            <div class="sm:col-span-3">
                <BaseInputText v-model="formValues.last_name" name="last_name" label="Last Name"></BaseInputText>
            </div>

            <div class="sm:col-span-3">
                <BaseInputText v-model="formValues.email" name="email" label="Email"></BaseInputText>
            </div>

            <div class="flex items-center pt-4 sm:col-span-3">
                <BaseInputCheckbox
                    v-model="formValues.is_beneficial_owner"
                    name="is_beneficial_owner"
                    :label="$t('legal_account_managers.beneficial_owner')"></BaseInputCheckbox>
            </div>
        </div>
        <div class="flex justify-end">
            <BaseButtonSecondary size="lg" @click="addManager()">Add Manager</BaseButtonSecondary>
        </div>
    </div>
</template>
